import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { supabase } from "../../supabase";
import { useAuth } from "../../contexts/AuthContext";
import { PersonIcon, ChartIcon } from "../icons";
import "./Sidebar.css";

const NAV_ITEMS = [
  { id: "create", label: "Create Tournament", icon: "＋" },
  { id: "tournaments", label: "Tournaments", icon: "⊞" },
  { id: "players", label: "Players", icon: <PersonIcon /> },
  { id: "statistics", label: "Statistics", icon: <ChartIcon /> },
  { id: "settings", label: "Settings", icon: "⚙" },
];

function Sidebar() {
  const { isGuest, signOut, exitGuest } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");

  useEffect(() => {
    if (isGuest) return;
    supabase.auth.getUser().then(({ data: { user } }) => {
      const name = user?.user_metadata?.username || user?.email || "";
      setUsername(name);
    });
  }, [isGuest]);

  async function handleLogout() {
    if (isGuest) exitGuest();
    else await signOut();
    navigate("/");
  }

  return (
    <aside className="sb">
      <div className="sb-logo">
        <span className="sb-logo-text">TOURNAMENT</span>
        <span className="sb-logo-sub">CITY</span>
      </div>

      <nav className="sb-nav">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.id}
            to={`/app/${item.id}`}
            className={({ isActive }) => `sb-item${isActive ? " active" : ""}`}
          >
            <span className="sb-icon">{item.icon}</span>
            <span className="sb-label">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="sb-footer">
        {isGuest ? (
          <div className="sb-user sb-guest">
            <span className="sb-user-avatar sb-guest-avatar">?</span>
            <div>
              <span className="sb-user-name">Guest</span>
              <span className="sb-guest-hint">Data not saved</span>
            </div>
          </div>
        ) : username ? (
          <div className="sb-user">
            <span className="sb-user-avatar">
              {username.charAt(0).toUpperCase()}
            </span>
            <span className="sb-user-name">{username}</span>
          </div>
        ) : null}

        <button className="sb-logout" onClick={handleLogout}>
          <span className="sb-icon">⏻</span>
          <span className="sb-label">
            {isGuest ? "Exit Guest Mode" : "Log Out"}
          </span>
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;
